import { render } from "./AdreseLivrare.vue?vue&type=template&id=539b5cfd&scoped=true&ts=true"
import script from "./AdreseLivrare.ts?vue&type=script&lang=ts"
export * from "./AdreseLivrare.ts?vue&type=script&lang=ts"

import "./AdreseLivrare.vue?vue&type=style&index=0&id=539b5cfd&scoped=true&lang=scss"

import exportComponent from "D:\\Melinda\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539b5cfd"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog,QCard,QBar,QTooltip,QSpace,QIcon,QCardSection});qInstall(script, 'directives', {ClosePopup});
